import Carousel from './carousel';

class FullScreenSliderCarousel extends Carousel {
  constructor(selector: any = '.js-o-fullscreen-slider-carousel', settings: object = {}) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const carousel: HTMLElement | null | undefined = el.closest('.o-fullscreen-slider');
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-fullscreen-slider__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      speed: SPEED,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: TIME,
      },
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: () => {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
        },
      },
    });
  }
}

export default FullScreenSliderCarousel;
